import {
  CardTaxWithholdingPromotion,
  useShowTaxWithholdingsPromotion
} from "./CardTaxWithholdingPromotion";
import {
  CardWalletPromotion,
  useShowWalletPromotion
} from "./CardWalletPromotion";

export const useShowPromotions = () => {
  const showTaxWithholdingsPromotion = useShowTaxWithholdingsPromotion();
  const showWalletPromotion = useShowWalletPromotion();

  return showTaxWithholdingsPromotion || showWalletPromotion;
};

export const Promotions: React.FC = () => {
  return (
    <>
      <CardTaxWithholdingPromotion />
      <CardWalletPromotion />
    </>
  );
};
